import API_BASE from "../config.js";
import { logout } from "../store/auth";

let refreshPromise = null;

function getAccessToken() {
  return sessionStorage.getItem("access_token") || localStorage.getItem("access_token") || "";
}
function getRefreshToken() {
  return sessionStorage.getItem("refresh_token") || localStorage.getItem("refresh_token") || "";
}

async function renovarToken() {
  if (refreshPromise) return refreshPromise;
  const rt = getRefreshToken();
  if (!rt) {
    logout();
    throw new Error("Sessao expirada (sem refresh token).");
  }
  refreshPromise = fetch(API_BASE + "/api/v1/auth/refresh", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: rt }),
  })
    .then(async (r) => {
      if (!r.ok) { logout(); throw new Error("Falha ao renovar sessao."); }
      const data = await r.json();
      sessionStorage.setItem("access_token", data.access_token);
      return data.access_token;
    })
    .finally(() => { refreshPromise = null; });
  return refreshPromise;
}

// Substituto drop-in para fetch() em chamadas autenticadas.
// Mesma assinatura, mesmo retorno (Response) -- so chama renovarToken() sozinho se vier 401.
export async function authFetch(url, options = {}) {
  const token = getAccessToken();
  const headers = { ...(options.headers || {}), Authorization: "Bearer " + token };
  // Sempre buscar dados frescos: sem isto o navegador podia servir uma
  // resposta antiga do cache HTTP (ex.: lista de O.S. sem a OS recem-criada
  // via conversao de agendamento), fazendo a tela parecer "travada" mesmo
  // com o dado ja no banco. "no-store" so afeta o cache da requisicao,
  // nao muda comportamento, layout nem fluxo.
  const cacheOpt = options.cache || "no-store";
  let res = await fetch(url, { ...options, headers, cache: cacheOpt });
  if (res.status === 401) {
    const novoToken = await renovarToken();
    const headers2 = { ...(options.headers || {}), Authorization: "Bearer " + novoToken };
    res = await fetch(url, { ...options, headers: headers2, cache: cacheOpt });
  }
  return res;
}
